import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { problems } from '../../data/content';
export function Problem() {
  return <section className="w-full bg-white px-4 py-14 sm:py-20" aria-labelledby="problem-title" data-id="element-285" data-mp="2rn3utypng0z8">
      <div className="mx-auto max-w-3xl" data-id="element-286" data-mp="2mo8zjxahwjy8">
        <SectionHeading id="problem-title" data-id="element-287" data-mp="2mnhhlp9tmkqf">
          When a post-laser reaction doesn't look routine, <span className="text-alert" data-id="element-288" data-mp="2ho4kmbp8jxa4">what's your next step?</span>
        </SectionHeading>

        <div className="mt-8 space-y-4 text-base leading-relaxed text-ink/80 sm:text-lg" data-id="element-289" data-mp="2ct8s7ag377wh">
          <p data-id="element-290" data-mp="28psyalvejlnh">A patient returns after an aesthetic laser procedure.</p>
          <p data-id="element-291" data-mp="23rhlq3dq2x1k">
            They report unexpected discomfort, persistent redness, changes in pigmentation, blistering, or an
            unusual healing pattern.
          </p>
          <p className="font-display text-xl font-extrabold text-navy-900" data-id="element-292" data-mp="1yjozwgtrkbc">
            You have observations. You have clinical experience.
          </p>
          <p data-id="element-293" data-mp="149qxify6pbwf">But organizing the information into a consistent assessment and documentation process can become challenging.</p>
          <p data-id="element-294" data-mp="vadmhiuewf9l">
            The problem isn't necessarily a lack of clinical knowledge. It's the{' '}
            <strong className="text-navy-900" data-id="element-295" data-mp="109gt37q1itjo">absence of a repeatable workflow</strong> that helps you organize relevant
            findings, recognize potential warning signs, and determine when additional clinical evaluation is
            appropriate.
          </p>
        </div>

        <div className="mt-8 rounded-3xl bg-alert/5 p-5 ring-1 ring-alert/20 sm:p-8" data-id="element-296" data-mp="1s2r1eiap0cf1">
          <p className="mb-4 font-display text-lg font-extrabold uppercase text-navy-900" data-id="element-297" data-mp="1e8zpj39hogg5">
            Without a structured process, you may encounter:
          </p>
          <ul className="space-y-3" data-id="element-298" data-mp="26wvt8rxh78mf">
            {problems.map(p => <li key={p} className="flex items-start gap-3 text-base text-ink/85" data-id="element-299" data-mp="2bodm0spci2wb">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-alert text-white" data-id="element-300" data-mp="2lkm12qhczu6u">
                  <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-301" data-mp="2gl9gkcdymz7f" />
                </span>
                {p}
              </li>)}
          </ul>
        </div>

        <p className="mt-8 text-center font-display text-xl font-black text-navy-900 sm:text-2xl" data-id="element-302" data-mp="26nd8jtgbkkdj">
          Your clinical judgment deserves an organized workflow to support it.
        </p>

        <SectionCTA label="I want an organized workflow" data-id="element-303" data-mp="22nkx98zjk04h" />
      </div>
    </section>;
}